module.exports = {
	save:'保存',
	cancel:'取消',
	back:'返回',
	define:'确定',
	edit:'编辑',
	add:'添加',
	del:'删除',
	search:'查询',
	state:'状态',
	operation:'操作',
	serialNum:'序号',
	info:'说明',
	all:'所有',
	refresh:'刷新',
	close:'关闭',
	detail:'详情',
	reset:'重置密码',
	lock:'锁定',
	status:{
		'normal':'正常',
		disable:'禁用',
		enable:'启用',
		yes:'是',
		no:'否',
	},
	datefrom:'开始日期',
	dateto:'结束日期',
	stateholder:'请选择状态',
	delmsg:'你确定要',
	datefrommsg:'开始日期不能为空',
	datetomsg:'结束日期不能为空',
	nodata:'暂无数据'
}



// WEBPACK FOOTER //
// ./src/i18n/locales/en-us/modules/global.js